export const isRouteAccessibile = (allowedScreens = [], routeScreen = '') =>
  allowedScreens.some(allowedScreen => allowedScreen.name === routeScreen);
